import React from "react";

import { SetupSection } from "./components/setup-section";
import { type PlatformDetails } from "./platform-details";

export function AmazonSeller({
  connectionContent,
}: {
  connectionContent: React.ReactNode;
}) {
  return (
    <SetupSection title="Log into Amazon Seller to connect integration">
      {connectionContent}
    </SetupSection>
  );
}

export const AmazonSellerDetails: PlatformDetails = {
  northbeamDocUrl: "https://docs.northbeam.io/docs/tracking-for-amazon",
  officialDocUrl: "",
  additionalDetails: [
    {
      title: "What does the Amazon Seller Integration track?",
      content: `Northbeam natively integrates with the Amazon Seller API.
        By doing so, we pull all your PPC revenue from your Amazon Marketplaces.`,
    },
    {
      title: "Why do I need to connect Amazon Seller?",
      content: "Amazon Seller fetches your store's revenue.",
    },
    {
      title: "Is there an integration with Amazon DSP or Vendor Central?",
      content: (
        <>
          We do not support Amazon DSP or Vendor Central at this time. If you'd
          like to upload costs from Amazon DSP, feel free to use a{" "}
          <a href="#">Custom Spendsheet</a>.
        </>
      ),
    },
  ],
};
